import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "formTitle": "NEXEN SAINTNINE Masters 2026\nPRO-AM RSVP",
          "privacyTitle": "Agreement on the Collection and Usage of Personal Information",
          "privacyContent": `
            The secreteriat seeks your permission for the collection and use of your personal information for the purpose of filling out the application form and managing the event.

            Your personal information will not be used for any purpose other than those stated above. The collected information will be securely destroyed after the event concludes.

            You have the right to refuse consent; however, please note that refusal to consent may result in restrictions on your participation in the event.

            Do you agree to the collection and use of your personal information as described above?`
          ,
          'yes': 'Yes',
          'no': 'No',
          'name': 'Name(Full Name)',
          'fullName': 'Full Name',
          'fullNameNotice': '※ Please enter your full name exactly as shown on your passport.',
          'gender': 'Gender',
          'male': 'Male',
          'female': 'Female',
          'birth': 'Date of Birth',
          'nationality': 'Nationality',
          'address': 'Address',
          'company': 'Company',
          'position': 'Position',
          'phoneNumber': 'Phone Number',
          'recipient': 'RSVP Recipient',
          'self': 'Self',
          'recipientName': 'RSVP Recipient Name',
          'recipientPhoneNumber': 'RSVP Recipient Phone Number',
          'recipientRelation': 'RSVP Recipient Relationship (Secretary, Subordinate Staff, etc.)',
          'preferredCallSchedule': 'Preferred Confirmation Call Schedule',
          'preferredCallDate': 'Preferred RSVP Confirmation Call Date',
          'preferredCallTime': 'Preferred RSVP Confirmation Call Time',
          'flight': "Flight Schedule\n(GIMPO ↔ PUSAN / GIMHAE)",
          'flightDeparture': 'GIMPO → PUSAN / GIMHAE',
          'flightArrival': 'PUSAN / GIMHAE → GIMPO',
          'flightOneWayNotice': "※ The 07:00 departure from Gimpo and the 20:00 departure from Gimhae listed below are reserved block seats for smooth Pro-Am operations.\nIf you prefer another departure city/airport or a different time, please select 'Others' and provide details.\nAlso, if you will use only one leg of the round-trip itinerary, please select 'Others' for the unused leg and enter 'Not using'.",
          'departureDefault': 'GIMPO → PUSAN / GIMHAE KE 07:00',
          'arrivalDefault': 'PUSAN / GIMHAE → GIMPO KE 20:00',
          'o': 'O',
          'x': 'X',
          'other': 'Others',
          'bagService': "Golf Bag Pickup / Delivery Service\n(Door to Door)",
          'bagServiceHelp': '※ Please note that this Door to Door service is limited to invited guests traveling domestically.\nGolf bag pickup is scheduled between Thu, Apr 9 and Sun, Apr 12 from 06:00 to 10:00.\nGolf bag delivery will proceed sequentially to the entered address between Thu, Apr 16 and Fri, Apr 17 after the Pro-Am event ends.\nPlease select your usage option considering both pickup and delivery schedules.',
          'bagAddress': 'Address for Golf bag Door to Door Service',
          'bagSchedule': 'Schedule for Golf bag Door to Door Service',
          'bagScheduleDate': 'Preferred Pickup Date',
          'bagScheduleTime': 'Time for Golf bag Door to Door Service',
          'bagServicePhoneNumber': 'Phone Number for Golf bag Door to Door Service',
          'shoeSize': 'Golf Shoes Size',
          'shoeSizeNotice': '※ Men: 250mm ~ 290mm, Women: 225mm ~ 250mm',
          'shoeSizeNoticeXs': '※ Men: 250mm ~ 290mm\n※ Women: 225mm ~ 250mm',
          'shoeGender': 'Gender Selection',
          'gloveSize': 'Golf Glove Size',
          'gloveMale': 'Male (Left or Right 22~26)',
          'gloveFemale': 'Female (Both hands 18~22)',
          'gloveGender': 'Gender Selection',
          'gloveLeftRight': 'Golf gloves Left or Right',
          'gloveDirectionNotice': '※ Golf glove direction is based on the hand on which you wear the golf glove.',
          'leftRight': 'Select Left or Right',
          'size': 'Size',
          'food': `Food and Other Requests
          (vegetarian, allergies, non-alcoholic, etc.)`,
          'submitHelp': `※ Please complete and submit the participation form by 12:00 PM on Tuesday, March 25th.`,
          'additional': `※ Inquiries : Secretariat (Mobile : +82-10-3907-9482, Email : dhwodn@brion.co.kr)`,
          'additionalXs': `※ Inquiries : Secretariat\nMobile : +82-10-3907-9482\nEmail : dhwodn@brion.co.kr`,
          'close': 'Close',
          'error': 'Error',
          'formError': 'Please check the input value following fields:',
          'submitSuccess': 'Your application has been successfully submitted.',
          'doneGuideLine1': 'After reviewing the information you entered, the event operations office will contact you soon for RSVP confirmation by phone.',
          'doneGuideLine2': 'We apologize for the inconvenience, and kindly ask you to confirm your final details with the operations office staff.',
          'doneGuideLine3': 'We look forward to seeing you at Gaya CC.',
          'networkError': 'Network error. Please try again. If the problem persists, please contact the secretariat.',
          'agreementError': 'Please agree to the collection and use of personal information.',
          'notification': 'Notification',
          'submit': 'Submit',
          'march': 'Mar',
          'april': 'Apr',
          'day': '',
          'monday': 'Mon',
          'tuesday': 'Tue',
          'wednesday': 'Wed',
          'thursday': 'Thu',
          'friday': 'Fri',
          'saturday': 'Sat',
          'sunday': 'Sun',
          'left': 'Left',
          'right': 'Right',
          'both': 'Both',
          'date': 'Date',
          'time': 'Time',
        }
      },
      ko: {
        translation: {
          "formTitle": "넥센 · 세인트나인 Masters 2026\n프로암 RSVP",
          "privacyTitle": "개인정보 수집 및 이용 동의",
          "privacyContent": `
            대회 사무국은 참가 신청서 작성 및 대회 운영을 위해 고객님의 개인정보를 수집하고자 합니다.
            수집된 개인정보는 프로암 참가 고객 관리 및 대회 운영 목적을 위해 사용됩니다.
            동의하신 개인정보는 위에 명시된 수집 및 이용 목적 외로 사용되지 않습니다.
            수집된 개인정보는 대회 종료 후 한 달 이내 안전하게 파기됩니다.
            귀하는 동의를 거부할 권리가 있으며, 동의 거부 시 대회 참가 신청이 제한될 수 있음을 안내드립니다.


            위의 개인정보 수집 및 이용에 동의하십니까?`
          ,
          'yes': '예',
          'no': '아니요',
          'name': '성함',
          'fullName': '영문 성함(Full Name)',
          'fullNameNotice': '※ 여권에 기재된 영문 이름과 동일하게 입력해 주세요.',
          'gender': '성별',
          'male': '남성',
          'female': '여성',
          'birth': '생년월일',
          'nationality': '국적',
          'address': '주소',
          'company': '회사',
          'position': '직위',
          'phoneNumber': '연락처',
          'recipient': 'RSVP 대상(본인, 기타)',
          'self': '본인',
          'recipientName': 'RSVP 대상 성함',
          'recipientPhoneNumber': 'RSVP 대상 연락처',
          'recipientRelation': 'RSVP 대상 관계(비서, 부하직원 등)',
          'preferredCallSchedule': '전화 RSVP 희망 스케줄',
          'preferredCallDate': '전화 RSVP 희망 일자',
          'preferredCallTime': '전화 RSVP 희망 시간',
          'flight': '항공 일정 (김포 ↔ 부산/김해)',
          'flightDeparture': '김포 → 부산/김해',
          'flightArrival': '부산/김해 → 김포',
          'flightOneWayNotice': "※ 아래 김포 출발 07시, 김해 출발 20시 항공편은 원활한 프로암 일정 진행을 위해 확보된 블록 항공편입니다. 다른 지역 또는 시간대 출발을 희망하실 경우 ‘기타’ 선택 후 상세 내용을 기입해 주시기 바랍니다. 또한 왕복 일정 중 편도만 이용하실 경우, 이용하지 않는 일정에는 ‘기타’ 선택 후 ‘미이용’으로 표기해 주시기 바랍니다.",
          'departureDefault': '김포 → 부산/김해 KE 07:00',
          'arrivalDefault': '부산/김해 → 김포 KE 20:00',
          'o': '이용',
          'x': '미이용',
          'other': '기타',
          'bagService': '캐디백 픽업 / 배송 서비스 (Door to Door)',
          'bagServiceHelp': '※ 캐디백 픽업은 4/9(목) ~ 4/12(일), 06:00 ~ 10:00 사이에 진행될 예정입니다.\n캐디백 배송은 프로암 이벤트 종료 후 4/16(목) ~ 4/17(금)에 입력해주신 주소로 순차 배송 예정입니다.\n픽업 및 배송 일정 참고하시어 이용 여부 선택 바랍니다.',
          'bagAddress': '캐디백 픽업/배송 주소',
          'bagSchedule': '캐디백 픽업 희망 스케줄',
          'bagScheduleDate': '캐디백 픽업 희망 일자',
          'bagScheduleTime': '캐디백 픽업 희망 시간',
          'bagServicePhoneNumber': '캐디백 픽업 담당자 연락처',
          'shoeSize': '골프화 사이즈',
          'shoeSizeNotice': '※ 남성 : 250mm ~ 290mm, 여성 : 225mm ~ 250mm',
          'shoeSizeNoticeXs': '※ 남성 : 250mm ~ 290mm\n※ 여성 : 225mm ~ 250mm',
          'shoeGender': '성별 구분',
          'gloveSize': '골프 장갑 사이즈',
          'gloveMale': '남성 (좌 or 우 22~26)',
          'gloveFemale': '여성 (양손 18~22)',
          'gloveGender': '성별 구분',
          'gloveLeftRight': '장갑 좌우',
          'gloveDirectionNotice': '※ 골프 장갑 방향은 골프 장갑을 착용하는 손 기준입니다.',
          'leftRight': '좌/우 선택',
          'size': '사이즈',
          'food': '식음 및 기타 요청 사항 (채식, 알레르기, 논알콜 등)',
          'submitHelp': `※ 신청서는 3/25(화) 정오까지 모든 항목의 답변을 작성하신 후 제출해 주시기 바랍니다.`,
          'additional': `※ 문의 : 대회사무국(Mobile : 010-3907-9482, Email : dhwodn@brion.co.kr)	`,
          'additionalXs': `※ 문의 : 대회사무국\nMobile : 010-3907-9482\nEmail : dhwodn@brion.co.kr`,
          'close': '닫기',
          'error': '오류',
          'formError': '다음 항목의 정보를 확인해 주세요:',
          'submitSuccess': '참가 신청이 완료되었습니다.',
          'doneGuideLine1': '입력해주신 정보 확인 후 곧 대회 운영 사무국에서 유선(전화) RSVP가 진행될 예정입니다.',
          'doneGuideLine2': '번거로우시더라도 운영 사무국 담당자와 입력하신 최종 정보 확인 부탁드립니다.',
          'doneGuideLine3': '가야CC에서 뵙겠습니다.',
          'networkError': '네트워크 오류입니다. 다시 시도해 주세요. 문제가 지속되면 사무국으로 연락해 주세요.',
          'agreementError': '개인정보 수집 및 이용에 동의해 주세요.',
          'notification': '알림',
          'submit': '제출',
          'march': '3월',
          'april': '4월',
          'day': '일',
          'monday': '월',
          'tuesday': '화',
          'wednesday': '수',
          'thursday': '목',
          'friday': '금',
          'saturday': '토',
          'sunday': '일',
          'left': '좌',
          'right': '우',
          'both': '양손',
          'date': '날짜',
          'time': '시간',
        }
      }
    },
    lng: "ko", // if you're using a language detector, do not define the lng option
    fallbackLng: "ko",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });
